import { apiConfig } from '../api-config';

export const generateLinkGix = (params: any) => {
  return apiConfig
    .get(`api/Gix/get-link-gix?cdTerritory=${params.cdTerritory}&tokenKey=${params.tokenKey}`)
    .then((resp) => resp.data.objectResult)
    .catch((err) => ({ hasErrors: true, err }));
};
